import type {PointSnapSettings} from '../manager/PointSnapManager';

/**
 * 自动几何关系的产品级固定状态。
 *
 * 设计说明：
 * 1. 自动几何关系是 cad-core 的草图绘制策略，不由 UI 或持久化数据决定；
 * 2. 所有设置入口复用该常量，避免不同宿主产生不一致的默认值；
 * 3. 保留设置字段是为了兼容现有项目数据结构，但运行时始终按开启处理。
 */
export const AUTO_GEOMETRY_RELATIONS_ENABLED = true;

/**
 * 归一化点捕捉设置并强制开启自动几何关系。
 *
 * 该函数在 cad-core 的 Viewer 边界和 web-client 的持久化边界复用，确保旧项目、
 * 外部 SDK 调用或响应式 UI 对象都无法把自动几何关系恢复为关闭状态。
 *
 * @param settings 调用方提供的点捕捉设置。
 * @returns 与调用方对象解除引用、保留输入字段必填性且自动几何关系已开启的设置快照。
 */
export function normalizePointSnapSettings<TSettings extends PointSnapSettings>(settings: TSettings) {
    return {
        ...settings,
        // 产品策略要求自动几何关系始终开启，忽略历史数据或外部调用中的关闭值。
        isAutoGeometryRelationsEnabled: AUTO_GEOMETRY_RELATIONS_ENABLED,
        // 捕捉项映射必须复制，避免 cad-core 与宿主共享可变对象引用。
        snapOptionState: {
            ...settings.snapOptionState,
        },
    };
}
